import React, { useState, useEffect, useRef } from 'react';
import './View2.css';
import '../../../components/styles/People.css';
import ImageWrapper from '../../ImageWrapper';
import { BottomButton } from '../../../styles/ButtonStyles';
import previousInactive from '../../../assests/arrow_back_grey.png'
import previousActive from '../../../assests/arrow_back.png'
import nextActive from '../../../assests/arrow_forward.png'
import ReviewView1 from '../../ReviewView1';
import urls from '../../../api/urls.json'
import { authorizedHttpPost, authorizedHttpGet } from '../../../api/httpCalls';
import Loader from '../../Loader';
import CropImage from '../../CropImage';
import ReviewPage from '../../ReviewPage';
import { convertTimestampToFormattedDate, getSafeMediaUrl } from "../../../utils";
import verified_icon from '../../../assests/verified.svg';
import { uploadCroppedImageToS3 } from '../../../api/imageUpload';
import VerifyModal from '../../modals/VerifyModal';
import '../../../components/styles/Verified.css';
import placeholder_image from '../../../assests/placeholder_image.png';
import ShareRefControl from '../../ShareRefControl';

const View2 = ({ profiles, cancelReview, isView2, page, afterSave, postUrl = urls.POST_IMAGES_UPDATES, sourceTab = 'Images', showStatusTag = false, likeLabel = 'Like', passLabel = 'Pass' }) => {
    const itemsPerPage = 1;
    const [currentPage, setCurrentPage] = useState(1);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentProfile = profiles.slice(startIndex, endIndex);
    const totalProfilePages = Math.ceil(profiles.length / itemsPerPage);
    const [displayReview, setDisplayReview] = useState(false);
    const [likedProfiles, setLikedProfiles] = useState([]);
    const [passedProfiles, setPassedProfiles] = useState([]);
    const [inappProfiles, setInappProfiles] = useState([]);
    const [decoy, setDecoy] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showCropImage, setShowCropImage] = useState(false);
    const [cropPhoto, setCropPhoto] = useState('');
    const [approvedRefs, setApprovedRefs] = useState([]);
    const [displaySelfieModal, setDisplaySelfieModal] = useState(false);

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (displayReview) {
                if (event.key === 'ArrowLeft') {
                    setDisplayReview(false)
                    setCurrentPage(totalProfilePages)
                }
            } else {
                if (event.key === 'ArrowLeft' && currentPage > 1) {
                    handleProfilePageChange('previous')
                } else if (event.key === 'ArrowRight' && currentPage < totalProfilePages) {
                    handleProfilePageChange('next')
                } else if (event.key === 'ArrowRight' && currentPage === totalProfilePages) {
                    setDisplayReview(true)
                } else if (event.key === 'Shift') {
                    handleActionButton(currentProfile, 'like');
                } else if (event.key === '/') {
                    handleActionButton(currentProfile, 'pass');
                } else if (event.key === 'i') {
                    inappProfile(currentProfile);
                }
            }
        };
        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    });

    const removeProfileByRef = (profileArray, refToRemove) => {
        return profileArray.filter((obj) => obj.ref !== refToRemove);
    };

    const isRefAlreadyPresent = (profileArray, refToFind) => {
        return profileArray.some((obj) => obj.ref === refToFind);
    }

    const inappProfile = (profile) => {
        if (isRefAlreadyPresent(inappProfiles, profile[0].ref)) {
            let removedProfile = removeProfileByRef(inappProfiles, profile[0].ref);
            setInappProfiles(removedProfile);
        } else {
            // Remove from other lists first
            const refToFind = profile[0].ref;
            const updatedLikedProfiles = removeProfileByRef(likedProfiles, refToFind);
            const updatedPassedProfiles = removeProfileByRef(passedProfiles, refToFind);
            setLikedProfiles(updatedLikedProfiles);
            setPassedProfiles(updatedPassedProfiles);
            setApprovedRefs(approvedRefs.filter((ref) => ref !== refToFind));
            
            setInappProfiles(existingData => ([...existingData, ...profile]));
            
            if (profiles.length === currentPage) {
                setDisplayReview(true);
            } else {
                setCurrentPage(currentPage + 1);
            }
        }
    }

    const handleApproveButton = (profile) => {
        const ref = profile[0].ref;
        if (approvedRefs.includes(ref)) {
            setApprovedRefs(approvedRefs.filter((approvedRef) => approvedRef !== ref));
        } else {
            // Approval is intentionally held until Accept is clicked. Accept
            // alone still advances and leaves the profile disapproved.
            setApprovedRefs(existingData => ([...existingData, ref]));
        }
    }

    const handleActionButton = (profile, button) => {
        let changeCurrentPage = false;
        if (button === 'like') {
            if (isRefAlreadyPresent(likedProfiles, profile[0].ref)) {
                changeCurrentPage = false;
                let removedProfile = removeProfileByRef(likedProfiles, profile[0].ref);
                setLikedProfiles(removedProfile);
            } else {
                const refToFind = profile[0].ref;
                const updatedPassedProfiles = removeProfileByRef(passedProfiles, refToFind);
                const updatedInappProfiles = removeProfileByRef(inappProfiles, refToFind);
                setPassedProfiles(updatedPassedProfiles);
                setInappProfiles(updatedInappProfiles);
                setLikedProfiles(existingData => ([...existingData, ...profile]));
                changeCurrentPage = true;
            }
        } else if (button === 'pass') {
            if (isRefAlreadyPresent(passedProfiles, profile[0].ref)) {
                changeCurrentPage = false;
                let removedProfile = removeProfileByRef(passedProfiles, profile[0].ref);
                setPassedProfiles(removedProfile);
            } else {
                const refToFind = profile[0].ref;
                const updatedLikedProfiles = removeProfileByRef(likedProfiles, refToFind);
                const updatedInappProfiles = removeProfileByRef(inappProfiles, refToFind);
                setLikedProfiles(updatedLikedProfiles);
                setInappProfiles(updatedInappProfiles);
                setApprovedRefs(approvedRefs.filter((ref) => ref !== refToFind));
                setPassedProfiles(existingData => ([...existingData, ...profile]));
                changeCurrentPage = true;
            }
        }

        if (profiles.length === currentPage) {
            setDisplayReview(true)
        }

        if (changeCurrentPage) { setCurrentPage(currentPage + 1); }
    }

    const handleProfilePageChange = (type) => {
        if (type === 'next') {
            const currentRef = currentProfile[0]?.ref;
            const approvalNeedsAccept = sourceTab === 'auto_updates_images' && currentRef &&
                approvedRefs.includes(currentRef) &&
                !isRefAlreadyPresent(likedProfiles, currentRef);

            if (approvalNeedsAccept) {
                alert('Click Accept before moving to the next profile.');
                return;
            }

            if (currentPage < totalProfilePages) {
                setCurrentPage(currentPage + 1)
            } else {
                setDisplayReview(true)
            }
        } else if (type === 'previous') {
            if (currentPage > 1) {
                setCurrentPage(currentPage - 1)
            }
        }
    }

    const setSelected = (photo_id) => {
        currentProfile[0].updated_images.map((obj) => {
            if (obj.photo_id === photo_id) {
                obj.selected = true;
            } else {
                obj.selected = false;
            }
        });
        setDecoy(!decoy)
    }

    const deleteImage = (photo_index) => {
        currentProfile[0].updated_images.splice(photo_index, 1);
        setDecoy(!decoy)
    }

    const addImage = (path) => {
        currentProfile[0].updated_images = [...currentProfile[0].updated_images, { photo: path }]
        setDecoy(!decoy)
    }

    const cancelSave = () => {
        setLikedProfiles([]);
        setPassedProfiles([]);
        setApprovedRefs([]);
        cancelReview()
        setDisplayReview(false);
        setCurrentPage(1);
    }

    const saveResults = async () => {
        if (likedProfiles.length === 0 && passedProfiles.length === 0 && inappProfiles.length === 0) {
            setApprovedRefs([]);
            return;
        }
        setIsLoading(true);
        let params = { "approve": likedProfiles, "reject": passedProfiles, "inappropriate": inappProfiles, "page": page, "approve_refs": approvedRefs, "tab": sourceTab.toLowerCase() };
        await authorizedHttpPost(postUrl, params);
        afterSave();
        setIsLoading(false);
        setDisplayReview(false);
        setCurrentPage(1);
        setLikedProfiles([]);
        setPassedProfiles([]);
        setInappProfiles([]);
        setApprovedRefs([]);
    };

    const openSelfieModal = (url) => {
        setDisplaySelfieModal(true);
    }

    const closeSelfieModal = () => {
        setDisplaySelfieModal(false);
    }

    const dragOverItem = useRef();
    const dragImageUrl = useRef();

    const dragStart = (e, position, url) => {
        dragImageUrl.current = url;
        dragOverItem.current = position;
    };

    const dragEnter = (e, position) => {
        dragOverItem.current = position;
    };

    const dropImage = () => {
        setDecoy(!decoy)
        currentProfile[0].updated_images[dragOverItem.current] = { "photo": dragImageUrl.current };
        dragImageUrl.current = null;
        dragOverItem.current = null;
    }

    const showImageCrop = (photo) => {
        setCropPhoto(photo)
        setShowCropImage(true);
    }

    const closeModal = () => {
        setShowCropImage(false);
    }

    const saveCroppedImage = async (croppedImage, index) => {
        try {
            // currentProfile[0].updated_images[localStorage.getItem('photoIndex')] = { "photo": croppedImage };
            const profileRef = currentProfile[0]?.ref;
            const s3Url = await uploadCroppedImageToS3(croppedImage, profileRef);
            const photoIndex = localStorage.getItem('photoIndex');
            currentProfile[0].updated_images[photoIndex] = { "photo": s3Url };
            setShowCropImage(false);
        } catch (error) {
            console.error("Error saving cropped image:", error);
        }
    }


    if (displayReview) {
        return (
            <>
                {isLoading && <Loader />}
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <ReviewPage likes={likedProfiles} passed={passedProfiles} inappProfiles={inappProfiles} ban={[]} tabType={'updates'} cancel={cancelSave} save={saveResults} approvedRefs={approvedRefs} approveLabel="Approve" rejectLabel="Reject" inappropriateLabel="Inappropriate" />
            </>
        )
    } else {
        return (
            <>
                {isLoading && <Loader />}
                {showCropImage ? <CropImage photo={cropPhoto} closeModal={closeModal} saveCroppedImage={saveCroppedImage} /> : null}
                {displaySelfieModal && currentProfile[0]?.selfie_url && (
                    <VerifyModal closeModal={closeSelfieModal} image={currentProfile[0].selfie_url} hide_buttons={true} />
                )}
                <div className='view2MainDiv'>
                    {
                        currentProfile[0] &&
                        <div className='headerDivViewTwo'>
                            <span>{currentProfile[0].first_name} </span>
                            <span>{currentProfile[0].is_verified ? <img src={verified_icon} alt="Verified" /> : null}/</span>
                            <span>{currentProfile[0].gender === 'Male' ? 'M' : 'F'} / </span>
                            <span>{currentProfile[0].age} / </span>
                            <span>{currentProfile[0].marital_status_v1 && currentProfile[0].marital_status_v1['name']} / </span>
                            <span>{currentProfile[0].language_name} / </span>
                            <span>{currentProfile[0].location_str} / </span>
                            <span>{currentProfile[0].ref} / </span>
                            <ShareRefControl
                                refValue={currentProfile[0].ref}
                                sourceTab={sourceTab === 'auto_updates_images'
                                    ? (currentProfile[0].profile_state === 'approved' ? 'Updates' : 'Images')
                                    : sourceTab}
                                compact={true}
                            />
                            <span>{convertTimestampToFormattedDate(currentProfile[0].application_date)} / </span>
                            <span>{currentProfile[0].phone_code} / </span>
                            <span>{currentProfile[0].is_paid_user ? 'Paid' : ''} </span>
                            <span>{currentProfile[0].last_curator === 'hive' ? 'HIVE/' : ''}</span>
                            {showStatusTag && <span className={`profileStatusTag ${currentProfile[0].profile_state === 'approved' ? 'approved' : 'disapproved'}`}>
                                {currentProfile[0].profile_state === 'image_inappropriate' ? 'Image Inappropriate' : (currentProfile[0].profile_state === 'disapproved' ? 'Disapproved' : 'Approved')}
                            </span>}
                        </div>
                    }
                    
                    <div className='updatedImagesContainer'>
                        {

                            currentProfile[0] && currentProfile[0].updated_images &&
                            [0, 1, 2, 3].map((image, index) => {
                                return (
                                    <div
                                        key={`updated-${index}`}
                                        onDragStart={(e) => dragStart(e, index, currentProfile[0].updated_images[image].photo)}
                                        onDragEnter={(e) => dragEnter(e, index)}
                                        onDragEnd={() => dropImage()}
                                        className='dragAndDropDiv'
                                    >
                                        <ImageWrapper key={index} src={currentProfile[0].updated_images[image]} addImage={addImage} selectedImage={setSelected} deleteImage={deleteImage} canDelete={currentProfile[0].updated_images.length > 1} toggleCrop={'showImageCrop'} closeModal={'closeModal'} showImageCrop={showImageCrop} photoIndex={index} />
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className='approvedImagesContainer'>
                        {
                            currentProfile[0] && currentProfile[0].approved_images &&
                            currentProfile[0].approved_images.slice(-4).map((photo, index) => {
                                return (
                                    <ImageWrapper key={`approved-${index}`} src={photo} addImage={() => { }} selectedImage={() => { }} deleteImage={() => { }} canDelete={currentProfile[0].approved_images.length > 1} toggleCrop={'showImageCrop'} closeModal={'closeModal'} photoIndex={index} />
                                )
                            })
                        }
                    </div>
                    
                    {
                        currentProfile[0] &&
                        <div className='buttonDiv'>
                            {currentPage === 1 ? <img src={previousInactive} alt='previous' className='previousViewTwo' /> : <img src={previousActive} alt='previous' className='previousViewTwo' onClick={() => handleProfilePageChange('previous')} />}
                            {(!showStatusTag || currentProfile[0].profile_state === 'disapproved') && <BottomButton onClick={() => handleApproveButton(currentProfile)} className={approvedRefs.includes(currentProfile[0].ref) ? 'likeActive' : 'likeInactive'}>Approve</BottomButton>}
                            <BottomButton onClick={() => handleActionButton(currentProfile, 'like')} className={isRefAlreadyPresent(likedProfiles, currentProfile[0].ref) ? 'likeActive' : 'likeInactive'}>{likeLabel}</BottomButton>
                            <BottomButton onClick={() => handleActionButton(currentProfile, 'pass')} className={isRefAlreadyPresent(passedProfiles, currentProfile[0].ref) ? 'passActive' : 'passInactive'}>{passLabel}</BottomButton>
                            <BottomButton onClick={() => inappProfile(currentProfile)} className={isRefAlreadyPresent(inappProfiles, currentProfile[0].ref) ? 'inappButtonActiveStyle' : 'inappButtonInActiveStyle'}>Inappropriate</BottomButton>
                            <img src={nextActive} alt='next' className='nextViewTwo' onClick={() => handleProfilePageChange('next')} />
                        </div>
                    }
                </div>
                
                {currentProfile[0] && !displaySelfieModal && (
                    <div className="selfieVerificationContainer">
                        {(() => {
                            const selfieUrl = currentProfile[0]?.selfie_url;
                            
                            if (selfieUrl) {
                                return (
                                    <div onClick={() => openSelfieModal(selfieUrl)}>
                                        <img 
                                            src={getSafeMediaUrl(selfieUrl, placeholder_image)} 
                                            alt="Selfie Verification" 
                                            className="selfieVerificationThumbnail"
                                            onError={(e) => e.target.src = placeholder_image}
                                        />
                                        <div className="selfieVerificationLabel">Selfie</div>
                                    </div>
                                );
                            }
                            
                            return (
                                <div className="noSelfieIndicator">
                                    <div className="noSelfieText">No<br/>Selfie</div>
                                </div>
                            );
                        })()}
                    </div>
                )}
            </>
        )
    }


};

export default View2;
